import EmptyReservations from 'components/HappeningNonContent/Reservations/EmptyReservations/EmptyReservations';

export default EmptyReservations;
